import React, { useEffect, useContext, useState } from "react";
import Container from "../../components/common/Container";
import Banner from "../../components/common/Banner";
import { Link } from "react-router-dom";
import Allsportdata from "../../components/allsportdata/Allsportdata";
import exchangeBanner from "../../assets/images/Exchange_Page_top.png";
import sidebarCard1 from "../../assets/images/cas-1.png";
import sidebarCard2 from "../../assets/images/cas-2.png";
import sidebarCard3 from "../../assets/images/cas-3.png";
import FeatureEvent from "../../components/common/FeatureEvent/FeatureEvent";
import useSocket from '../../Websoket.js';
import { PopupContext } from "../../components/LoginPopup/LoginPopupContext.js";
import { filterByKeyword } from "../../Utils.js";
import AllsportdataTest from "../../components/allsportdata/AllsportdataTest.js";
import { SocketContext } from "../../SocketContext.js";

function Exchange() {
  const [matchdatas, setMatchData] = useState({});
  const [selectedTypes, setSelectedTypes] = useState("time");
  document.title = 'Exchange';
  const [endPoint, setEndPoint] = useState('cricket');
  const [activeTab, setActiveTab] = useState('Cricket');
  const [countArray, setCountArray] = useState([]);
  const { isConnected, sendMessage,getAllBets } = useContext(SocketContext);
  const [firstTimeCall, setFirstTimeCall] = useState(false)
  const { loggedIn } = useContext(PopupContext);

  useEffect(() => {    
          let intervalId;
          if (isConnected) {
              let matchdata = null;
              let userData = sessionStorage.getItem('userId')
              if(userData){
                  matchdata =  {
                      "id": userData
                  }
              }else{
                  matchdata = ""
              }
              if (!firstTimeCall) {
                  setFirstTimeCall(true)
                  sendMessage('AllOPenBets', matchdata);                
              }
              intervalId = setInterval(() => {
                  sendMessage('AllOPenBets', matchdata);
              }, 5000);
          }
          return () => {
              if (intervalId) {
                  clearInterval(intervalId);
              }
          };
      }, [isConnected, sendMessage, getAllBets]);


  const fetchData = (currentTab,selectedTypes) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/games/getExchangeData?type=${currentTab}&filter=${selectedTypes}`,
      requestOptions
    )
      .then(async (response) => {
        let paresData = await response.json();
        localStorage.setItem(currentTab,JSON.stringify(paresData));
        setMatchData(paresData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const countAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/games/liveCountData`,
      requestOptions
    )
      .then(async (response) => {
        let paresData = await response.json();
        setCountArray([]);
        setCountArray(paresData.result);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleTypeChange = (event) => {
    setSelectedTypes(event.target.value);
    // fetchData(endPoint,event.target.value);
  };

  const handleTab =(currentTab) => {
    setActiveTab(currentTab);
    let data = "All"
    if(currentTab === 'Cricket'){
        setEndPoint('cricket');
        data = 'cricket';
    }else if(currentTab === 'Football'){
        setEndPoint('football');
        data = 'football';
    }else if(currentTab === 'Tennis'){
        setEndPoint('tennis');
        data = 'tennis';
    }else if(currentTab === 'Election'){
        setEndPoint('election');
        data = 'election';
    }else if(currentTab === 'Kabaddi'){
        setEndPoint('kabaddi');
        data = 'kabaddi';
    }else if(currentTab === 'HorseRacing'){
        setEndPoint('horseracing');
        data = 'horseracing';
    }else if(currentTab === 'GreyhoundRacing'){
        setEndPoint('greyhound');
        data = 'greyhound';
    }if(currentTab === 'All'){
        setEndPoint('All');
        data = 'All';
    }
    // fetchData(data,selectedTypes)
}

  const getCount = (type) => {
    return countArray.find(item => item.name === type)?.count || 0;
  }

  const getAllSportCount = () => {
    return countArray.reduce((sum, item) => sum + item.count, 0);
  }

  useEffect(() => {
    countAPI(); // Initial fetch
    const interval = setInterval(() => {
      countAPI();
    }, 60000); // 60000ms = 1 minute

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useEffect(() => {
    if (localStorage.getItem(endPoint)) {
      let paresData = JSON.parse(localStorage.getItem(endPoint));
      setMatchData(paresData);
    }
    fetchData(endPoint,selectedTypes);
    const interval = setInterval(() => { fetchData(endPoint,selectedTypes); }, 60000);
    return () => clearInterval(interval);
  }, [endPoint,selectedTypes]);

  return (
    <>
      {matchdatas && (
        <Container size="full">
        <div className='mobile-sport-menu'>
    <ul>
        <li><span onClick={()=>handleTab("All")} className={`mobile-tab-btn ${activeTab === 'All' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='' src="../images/trophy.png" /></span> All Sports<strong className="live-count">{getAllSportCount()}</strong></span> </li>
        <li><span onClick={()=>handleTab("Cricket")} className={`mobile-tab-btn ${activeTab === 'Cricket' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Cricket' src='../images/cricket-ball.png' /></span> Cricket <strong className="live-count">{getCount('Cricket')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Football")} className={`mobile-tab-btn ${activeTab === 'Football' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Football' src='../images/football.png' /></span> Football <strong className="live-count">{getCount('Football')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Tennis")} className={`mobile-tab-btn ${activeTab === 'Tennis' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Tennis' src='../images/tennis.png' /></span> Tennis <strong className="live-count">{getCount('Tennis')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Election")} className={`mobile-tab-btn ${activeTab === 'Election' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Election' src='../images/mayor.png' /></span> Election <strong className="live-count">{getCount('Election')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Kabaddi")} className={`mobile-tab-btn ${activeTab === 'Kabaddi' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Kabaddi' src='../images/kabaddi.png' /></span> Kabaddi <strong className="live-count">{getCount('Kabaddi')}</strong></span> </li>
        <li><span onClick={()=>handleTab("HorseRacing")} className={`mobile-tab-btn ${activeTab === 'HorseRacing' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Horse Racing' src='../images/horse.png' /></span> Horse Racing <strong className="live-count">{getCount('HorseRacing')}</strong></span> </li>
        <li><span onClick={()=>handleTab("GreyhoundRacing")} className={`mobile-tab-btn ${activeTab === 'GreyhoundRacing' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Greyhound Racing' src='../images/dog.png' /></span> Greyhound Racing <strong className="live-count">{getCount('GreyHound')}</strong></span> </li>
    </ul>
    </div>
          <div className="content-w-sidebar exchange-page">
            <div className="left-content">
            <div className="banner">
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("Exchange_Page_top")} style={{ display: activeTab === 'All' ? "block" : "none" }}/>
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("Cricket_top")} style={{ display: activeTab === 'Cricket' ? "block" : "none" }}/>
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("football_top") } style={{ display: activeTab === 'Football' ? "block" : "none" }}/>
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("Tennis_Top") } style={{ display: activeTab === 'Tennis' ? "block" : "none" }}/>
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("election_top") } style={{ display: activeTab === 'Election' ? "block" : "none" }}/>
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("kabbadi_top") } style={{ display: activeTab === 'Kabaddi' ? "block" : "none" }}/>
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("horse_top") } style={{ display: activeTab === 'HorseRacing' ? "block" : "none" }}/>
              <img decoding="async" alt="" loading="lazy" src={filterByKeyword("greyhound_top") } style={{ display: activeTab === 'GreyhoundRacing' ? "block" : "none" }}/>
            </div>
              <div className="filter-btn-wrapper">
                <FeatureEvent />
                <div className="filter-btn">
                  <span>
                    View by:
                  </span>
                  <select
                    name="filterby"
                    id="filterby"
                    value={selectedTypes}
                    onChange={handleTypeChange}
                  >
                    <option value="competitions" selected="">
                      Competitions
                    </option>
                    <option value="time">Time</option>
                  </select>

                </div>
              </div>
              <div className='allsport-tab'>
            <span onClick={()=>handleTab("All")} className={`tab-btn ${activeTab === 'All' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='All Sports' src='../images/trophy.png' /> All Sports<strong className="live-count">{getAllSportCount()}</strong></span>
            <span onClick={()=>handleTab("Cricket")} className={`tab-btn ${activeTab === 'Cricket' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Cricket' src='../images/cricket-ball.png' /> Cricket<strong className="live-count">{getCount('Cricket')}</strong></span>
            <span onClick={()=>handleTab("Football")} className={`tab-btn ${activeTab === 'Football' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Football' src='../images/football.png' /> Football<strong className="live-count">{getCount('Football')}</strong></span>
            <span onClick={()=>handleTab("Tennis")} className={`tab-btn ${activeTab === 'Tennis' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Tennis' src='../images/tennis.png' />  Tennis<strong className="live-count">{getCount('Tennis')}</strong></span>
            <span onClick={()=>handleTab("Election")} className={`tab-btn ${activeTab === 'Election' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Election' src='../images/mayor.png' /> Election<strong className="live-count">{getCount('Election')}</strong></span>
            <span onClick={()=>handleTab("Kabaddi")} className={`tab-btn ${activeTab === 'Kabaddi' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Kabaddi' src='../images/kabaddi.png' /> Kabaddi<strong className="live-count">{getCount('Kabaddi')}</strong></span>
            <span onClick={()=>handleTab("HorseRacing")} className={`tab-btn ${activeTab === 'HorseRacing' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Horse Racing' src='../images/horse.png' /> Horse Racing<strong className="live-count">{getCount('HorseRacing')}</strong></span>
            <span onClick={()=>handleTab("GreyhoundRacing")} className={`tab-btn ${activeTab === 'GreyhoundRacing' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Greyhound Racing' src='../images/dog.png' /> Greyhound Racing<strong className="live-count">{getCount('GreyHound')}</strong></span>
        </div>
              <AllsportdataTest matchData={matchdatas} selectedTypes={selectedTypes} />
            </div>
            <div className="right-content sidebar">
              <div className="sidebar-box">
                <div className="title">All Casino</div>
                <div className="sidebar-card">
                  <Link to="/Royal_casino">
                    {" "}
                    <img decoding="async" loading="lazy" alt="" src={`${localStorage.getItem("adminurl")}sliderImages/RoyalGamings.webp`} />
                  </Link>
                  <Link to="/live_casino?provider=Ezugi">
                    {" "}
                    <img decoding="async" loading="lazy" alt="" src={`${localStorage.getItem("adminurl")}sliderImages/Ezugi.webp`} />
                  </Link>
                  <Link to="/slots">
                    {" "}
                    <img decoding="async" loading="lazy" alt="" src={`${localStorage.getItem("adminurl")}sliderImages/Slots.webp`} />
                  </Link>
                  <Link to="/live_casinoInPlay/68592667195d86359e880f39">
                    {" "}
                    <img decoding="async" loading="lazy" alt="" src={`${localStorage.getItem("adminurl")}sliderImages/Aviator.webp`} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Container>
      )}
    </>
  );
}

export default Exchange;
